<template>
  <header>
    <div class="logo">
      <img src="@/assets/images/cloud-sun.svg" /> Fine Weather
    </div>
    <ol class="links">
      <li>
        <a href="https://gitlab.soraharu.com/XiaoXi/Fine-Weather" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <g>
              <rect width="512" height="512" transform="rotate(180 12 12)" opacity="0" />
              <path
                d="M120.548,48.424c-2.785-7.996-14.104-7.996-16.979,0L52.813,205.457h118.583    C171.306,205.457,120.548,48.424,120.548,48.424z M26.849,284.512c-2.336,7.188,0.271,15.183,6.379,19.765l222.703,165.296    L52.722,205.457L26.849,284.512z M171.306,205.457l84.715,264.115l84.715-264.115H171.306z M485.189,284.512l-25.872-79.055    L256.021,469.572l222.703-165.296C484.92,299.694,487.436,291.699,485.189,284.512z M408.471,48.424    c-2.785-7.996-14.104-7.996-16.979,0l-50.848,157.033h118.584L408.471,48.424z"
              />
            </g>
          </svg>
          <span>GitLab</span>
        </a>
      </li>
    </ol>
  </header>
</template>

<script>
export default {
  name: "Hearder",
};
</script>

<style scoped>
header {
  display: flex;
  padding: 0 48px;
  height: 64px;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  border-bottom: 1px solid #eaeaea;
  background: #fafafa;
}
header .logo {
  font-size: 26px;
  font-weight: 600;
  font-style: italic;
  color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
}
header .logo img {
  height: 24px;
  padding-right: 8px;
}
header ol {
  list-style: none;
}
header ol a {
  height: 30px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #242424;
  font-weight: 500;
  font-size: 16px;
  padding: 0 8px;
  border: 2px solid #242424;
  box-sizing: border-box;
  fill: #242424;
  text-decoration: none;
}
header ol a:hover {
  background: #242424;
  color: #fff;
  fill: #fff;
  transition: ease 0.2s;
}
header ol a:active {
  background: #000;
}
header ol svg {
  padding-right: 4px;
  height: 16px;
}
header ol span {
  padding-top: 1px;
}

@media (max-width: 768px) {
  header {
    padding: 0px 16px;
  }
}
</style>